import type { ComponentProps, FC } from "react";

import { Stack } from "@similarweb/ui-components/foundations";

export const AlertPageContainer: FC<ComponentProps<typeof Stack>> = ({ children, ...props }) => {
    return (
        <Stack
            gap="16px"
            alignItems="center"
            justifyContent="center"
            position="absolute"
            top="0"
            left="0"
            right="0"
            bottom="0"
            {...props}
        >
            {children}
        </Stack>
    );
};
